var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"page-title"},[_vm._v("PRIVACY POLICY")]),_c('PrivacyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }